<div class="modal-content h-100 d-flex flex-column">
    <div class="modal-header">
        <h5 class="modal-title text-center">
            {{
                'SMARTLOCKER_DOOR_ACCESS_TITLE' | translate: { doorId: smartlockerDoorId, smartlockerId: smartlockerId }
            }}
        </h5>
        <span class="close" (click)="close()">&times;</span>
    </div>
    <ng-template #loading>
        <div class="flex-grow-1 d-flex justify-content-center px-3 my-5">
            <progressbar [value]="100" type="info">{{
                'SMARTLOCKER_RETRIEVING_ACCESS_CODE_LABEL' | translate
            }}</progressbar>
        </div>
    </ng-template>
    <ng-container *ngrxLet="smartlockerAccessCodeResponse$ as smartlockerAccessCodeResponse; suspenseTpl: loading">
        <div class="modal-body" id="modal-body">
            <div class="d-flex h-100 justify-content-center align-items-center p-3">
                @if (smartlockerAccessCodeResponse.BarcodeBase64) {
                    <div class="barcode-wrapper text-center w-100 my-md-3">
                        <img [src]="smartlockerAccessCodeResponse.BarcodeBase64" alt="Access Code Barcode" />
                    </div>
                } @else {
                    <p class="text-danger">
                        {{ 'SMARTLOCKER_RETRIEVING_ACCESS_CODE_FAILURE' | translate }} {{ this.smartlockerId }}
                    </p>
                }
            </div>
        </div>
        <div class="modal-footer">
            @if (smartlockerAccessCodeResponse.BarcodeBase64.length > 0) {
                <div class="d-flex">
                    <button
                        type="button"
                        class="btn btn-primary flex-grow-1"
                        [disabled]="!smartlockerAccessCodeResponse.IsSuccess"
                        (click)="onConfirmedDoorOpenedClick(smartlockerAccessCodeResponse.AccessCode)"
                    >
                        <fa-icon [icon]="faDoorOpen" class="me-2"></fa-icon>
                        <span [translate]="'SMARTLOCKER_CONFIRM_DOOR_OPENED_BTN_LABEL'"></span>
                    </button>
                </div>
            }
        </div>
    </ng-container>
</div>
